import { render } from "./radio.md?vue&type=template&id=22808a9f"
import script from "./radio.md?vue&type=script&lang=js"
export * from "./radio.md?vue&type=script&lang=js"
script.render = render

export default script